var exports = {
  "HU": "xfb577c5e--831184--aside",
  "qf": "xfb577c5e--831184--sticky",
  "DW": "xfb577c5e--831184--sticky-top-space",
};

module.exports = exports;
